const aiGeneratorNorwegian = {
  header: {
    title: "AI Innlegg Generator",
    description: "La AI hjelpe deg med å skape engasjerende LinkedIn-innlegg basert på dine preferanser"
  },
  customerBanner: {
    working: "Du genererer nå innlegg for"
  },
  loading: {
    posts: "Laster inn dine nyeste AI-genererte innlegg..."
  },
  noPosts: {
    title: "Ingen innlegg funnet",
    description: "Systemet ditt genererer automatisk nye LinkedIn-innlegg til deg hver uke. Når AI genererer innleggene dine, vil de dukke opp her, hvor du kan redigere og planlegge dem.",
    settings: "Hvis du ikke vil vente, kan du gå til",
    settingsLink: "Innstillinger",
    settingsAfter: "for å endre dine preferanser."
  },
  post: {
    author: "LinkedIn Bruker",
    time: "Nå •",
    editHint: "Trykk Ctrl+Enter for å lagre, Esc for å avbryte"
  },
  stats: {
    likes: "0",
    comments: "0",
    shares: "0"
  },
  aiPrompt: {
    placeholder: "Beskriv hvordan innlegget skal forbedres...",
    editing: "Redigerer",
    send: "Send"
  },
  buttons: {
    retry: "Prøv igjen",
    generating: "Genererer",
    removeImage: "Fjern bilde",
    nextImage: "Neste",
    addImage: "Bilde",
    accept: "Godta",
    scheduling: "Planlegger...",
    calculatingTimes: "Beregner tider...",
    noAvailableTimes: "Ingen ledige tider"
  },
  gallery: {
    title: "Velg et bilde",
    noImages: "Du har ingen bilder i arkivet ditt.",
    goToArchive: "Gå til bildearkiv"
  },
  imageOptions: {
    title: "Legg til bilde",
    gallery: "Velg fra bildearkiv",
    upload: "Last opp nytt bilde",
    camera: "Ta bilde",
    manage: "Administrer bildearkiv"
  },
  messages: {
    imageUpdated: "Bilde oppdatert!",
    imageRemoved: "Bilde fjernet!",
    savedChanges: "Endringer lagret!",
    regenerated: "Innlegget har blitt regenerert!",
    updated: "Innlegget har blitt oppdatert!",
    newPost: "Nytt innlegg opprettet!",
    accepted: "Ditt innlegg har blitt godkjent og flyttet til \"Mine Innlegg\", hvor du kan planlegge det for deling på LinkedIn!",
    calculatingTimes: "Beregner ledige tider...",
    noScheduledTimes: "Det er ingen planlagte tider satt i din planlegger. Gå til Planlegger for å sette opp tider.",
    postScheduled: "Innlegg planlagt til {formattedDate}",
    imageUploaded: "Bilde lastet opp og lagt til innlegget ditt!",
    error: "Det oppstod en feil. Prøv igjen senere."
  }
};

export default aiGeneratorNorwegian; 